import React, { useState, useEffect } from "react";
import { connect } from "formik";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { loanTypeList } from "constants/loanTypes";
import interestRateTypeIds from "constants/interestRateTypes";

import { SectionGrid, StyledAutoCompleteInput, StyledTextInput, StyledPercentInput, StyledLabel } from "../styles";

import FormSectionTitle from "./FormSectionTitle";

const LoanAssumptionsSection = props => {
  const { formik, interestRateTypes, floatingIndices, fixedIndices, setLoanProceedAssumptions } = props;
  const { values, setFieldTouched } = formik;
  const [rateIndexOptions, setRateIndexOptions] = useState([]);

  useEffect(() => {
    if (values?.interestRateType) {
      setRateIndexOptions(values.interestRateType === interestRateTypeIds.FLOATING ? floatingIndices : fixedIndices);
    }
  }, [values?.interestRateType]);

  if (!interestRateTypes) {
    return null;
  }

  const loanTypeListFiltered = loanTypeList.filter(x => x.isAssumptionType);

  return (
    <>
      <Grid item xs={12}><FormSectionTitle title="LOAN ASSUMPTIONS" /></Grid>
      <SectionGrid container item xs={12} alignItems="center" justify="flex-start" spacing={8}>
        <Grid item xs={3}>
          <StyledAutoCompleteInput
            label={<StyledLabel>{"Loan Type"}</StyledLabel>}
            fieldName="loanType"
            selectValue="value"
            options={loanTypeListFiltered}
            onChange={e => {
              setLoanProceedAssumptions(e, formik);
              setFieldTouched("loanType", true);
            }}
          />
          {" "}
        </Grid>
        <Grid item xs={3}><StyledTextInput label="Term (m)" fieldName="loanTerm" /></Grid>
        <Grid item xs={3}><StyledTextInput label="Amort. Term (m)" fieldName="amortizationTerm" /></Grid>
      </SectionGrid>
      <SectionGrid container item xs={12} alignItems="center" justify="flex-start" spacing={8}>
        {/* <Grid item xs={3}><StyledPercentInput label="Index Rate" decimalScale={3} fieldName="treasuryRate" onChange={e => { handleChange(e); const spread = parseFloat(values.spread) ; const treasuryRate = parseFloat(e.target.value); const updated = treasuryRate + spread; const allInRate = {target:{name: "allInRate", value:updated }} handleChange(allInRate); }}/> </Grid> */}
        <Grid item xs={3}>
          <StyledAutoCompleteInput label={<StyledLabel>Interest Rate Type</StyledLabel>} fieldName="interestRateType" selectValue="value" options={interestRateTypes} />
          {" "}
        </Grid>
        <Grid item xs={3}>
          <StyledAutoCompleteInput label={<StyledLabel>Rate Index</StyledLabel>} fieldName="rateIndex" selectValue="value" options={rateIndexOptions} />
          {" "}
        </Grid>
        <Grid item xs={3}>
          <StyledPercentInput label="Spread" decimalScale={3} fieldName="spread" />
          {" "}
        </Grid>
        {values.interestRateType === interestRateTypeIds.FLOATING && <Grid item xs={3}>
          <StyledPercentInput label="Underwr. Rate (Floating)" decimalScale={3} fieldName="UwRate" />
          {" "}
        </Grid>}
      </SectionGrid>
    </>
  );
};
export default compose(
  connect
)(LoanAssumptionsSection);
